module.exports = __webpack_public_path__ + "img/tan-lih-chen-v2.0b9f80f9.png";